module.exports = __webpack_public_path__ + "static/media/tai.f73c474a.webp";